import Api from "./Base";

export function reportApplyApplcation(data) {
    return Api.post(`/report_statuses`, data);
}

export function deleteApplyApplication(id) {
    return Api.post(`apply_application/${id}/delete`);
}
